import React, { useState } from "react";

export default function AdminDropDropDown(props) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button
      style={{width: props.width}}
        className="text-[#788188] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] focus:outline-non h-[2.5rem] font-medium rounded-[8px] text-sm px-3 py-2.5 text-center inline-flex items-center justify-between"
        type="button"
        onClick={() => setOpen(!open)}
      >
        {props.selected}
        <svg
          className="w-2.5 h-2.5 ml-2.5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 10 6"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m1 1 4 4 4-4"
          />
        </svg>
      </button>

      {open && (
        <div
          id="dropdown"
          className="z-10 absolute mt-1 bg-white divide-y divide-gray-100 rounded-lg shadow w-full"
        >
          <ul className="py-2 text-sm text-gray-700">
            {props?.options &&
              props?.options?.map((item) => {
                return (
                  <li className="block">
                    <button
                      className="px-4 py-2 w-full text-left hover:bg-gray-50 focus:bg-gray-100"
                      onClick={() => {
                        props.setSelected(item);
                        setOpen(false);
                      }}
                    >
                      {item}
                    </button>
                  </li>
                );
              })}
          </ul>
        </div>
      )}
    </div>
  );
}
